// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"styles-module__sectionHeader___lZMz_"};